import useStoreVuex from './useStoreVuex'

/**
 * useStore
 *
 * How to use:
 * const { mapActions, mapGetters, mapState } = useStore()
 * const { openPillars } = mapGetters('pillars')
 * const { personId } = mapState('pillars')
 * const { generateIAContent } = mapActions('pillars/clinicalRecord')
 *
 * console.log(openPillars)
 * console.log(personId)
 * console.log(generateIAContent())
 *
 * @returns { mapActions, mapGetters, mapState }
 */
export const useStore = useStoreVuex
